import { useLeadCollection } from '@/hooks/useLeadCollection.ts';
import type { LeadCollectionCounts } from '@/models/ui/LeadCollection.ts';
export function useLeadCollectionCounts(): LeadCollectionCounts {
  return useLeadCollection().counts;
}
